import Vue from "vue";
import Router from "vue-router";
import { Trans } from '@/plugins/Translation';
import routes from './routes';
import store from '../store';


Vue.use(Router);

const router = new Router({
  routes,
  mode: 'history',
  base: __dirname,
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition){
      return savedPosition
    }
    if(to.name != from.name){
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // if(to.name=='UserMain' && JSON.parse(localStorage.getItem('user_profile'))){
  //   console.log("get agency data")
  //   store.dispatch('AdminAgencyController/VERIFY_USER_AGENCY')
  // }
  if(!store.getters["UserController/isMobile"])
  {
    if(to.name != "ListingDetail" && to.name != "SearchGrid" ){
      store.commit('CategoryController/SET_EMPTY_FILLTER')
    }
  } else{
    if(to.name != "ListingDetail" && to.name != "MobileAdvanceSearch" && to.name != "SearchGrid"){
      store.commit('CategoryController/SET_EMPTY_FILLTER')
    }
  }
  
  if(localStorage && localStorage.getItem('user_profile')){
    var permissionType = JSON.parse(localStorage.getItem('user_profile')).admin_type
  }else{
    var permissionType = { id: 0 }
  }
  document.title = to.meta.title;
  if(to.matched.some(record => record.meta.userAuth)) {
    if(localStorage.getItem('user_profile')){
      Trans.routeMiddleware(to, from, next);
    }else if(to.name!='AddListing'){
      next({ name: ""})
    }
  }else if(to.matched.some(record => record.meta.adminAuth)){
    if(localStorage.getItem('user_profile') && (permissionType.id == 1 || permissionType.id == 2)){
      Trans.routeMiddleware(to, from, next);
    }else{
      next({ name: ""})
    }
  }else{
    Trans.routeMiddleware(to, from, next);
  }
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));
});
export default router;